
export default {
    methods: {
        async logout() {
            await this.$auth.unsetUser();
            await this.$router.push('/');
        },
    },
};
